module.exports = "/_next/static/chromiums/twitter-512x512-products-strawberry-creme-organic-lip-balm-66374a208ef97f535969b7edf7882af1.jpg";